import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { HotelAvailabilityMap } from "@tenant/hotels";
import { Dialog, DialogContent } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./AvailabilityMapDialog.module.scss";

type AvailabilityMapDialogProps = PlatformComponentProps & {
  dialogProps?: React.ComponentProps<typeof Dialog>;
  dialogContentProps?: React.ComponentProps<typeof DialogContent>;
  mapProps: React.ComponentProps<typeof HotelAvailabilityMap>;
};

export const AvailabilityMapDialog = ({
  dialogProps,
  mapProps,
  dialogContentProps,
  className,
  children,
}: AvailabilityMapDialogProps) => {
  const styles = useHotelsStyles(
    CoreHotelsComponent.AvailabilityMapDialog,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(
    styles,
    CoreHotelsComponent.AvailabilityMapDialog
  );
  const { t } = useI18nContext();
  return (
    <Dialog {...dialogProps}>
      <DialogContent
        title={t("core-hotels.availabilityPage.map.title")}
        className={clsx(block, className)}
        fullScreen
        {...dialogContentProps}
      >
        <HotelAvailabilityMap className={cn("map-dialog")} {...mapProps} />
        {children}
      </DialogContent>
    </Dialog>
  );
};
